import React, { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { Button } from "semantic-ui-react";
import { ModalBuilder, Modal, Form, useFormState } from "@redriver/cinnamon";
import { addGroup } from "./actions";
import { checkValidGroupName } from "./actions";
import { sitesLookup } from "modules/lookups";
import { SitePermission } from "constants/enums";

const permissionOptions = [
  { value: SitePermission.View, text: "View" },
  { value: SitePermission.Edit, text: "Edit" },
];

const AddGroup = ({ as: As = Button, onAdded, siteId, ...props }) => {
  const dispatch = useDispatch();
  const formState = useFormState();

  const [checkingName, setCheckingName] = useState(false);
  const [isValidName, setIsValidName] = useState(false);
  const [formValid, setFormValid] = useState(false);
  const [showErrors, setShowErrors] = useState(false);

  const setNameIsValidFromResponse = useCallback(
    (response) => {
      setIsValidName(
        !!response &&
          (!formState.errors.name || formState.errors.name.length == 0)
      );
    },
    [formState.errors]
  );

  return (
    <ModalBuilder
      withForm
      initialData={{
        siteId: siteId || null,
        permission: SitePermission.View,
      }}
      submitAction={addGroup}
      onSubmitted={() => {
        if (onAdded) onAdded();
        setShowErrors(false);
        setIsValidName(false);
      }}
      renderTrigger={(showModal) => <As onClick={showModal} {...props} />}
      renderModal={(modalProps, formProps, state, events) => (
        <Modal
          {...modalProps}
          header="Add Group"
          submitLabel="Add"
          size="tiny"
          onSubmit={() => {
            setShowErrors(true);
            if (formValid && isValidName && !checkingName) {
              events.onSubmit();
            }
          }}
        >
          <Form
            {...formProps}
            onValidated={(isValid) => setFormValid(isValid)}
            showErrors={showErrors}
          >
            {(fields, errors) => (
              <React.Fragment>
                <Form.Input
                  label="Name"
                  field="name"
                  fluid
                  required
                  showErrors={showErrors || (!isValidName && !!fields.name)}
                  customValidator={() => {
                    if (formProps.value.name) {
                      setCheckingName(true);
                      dispatch(checkValidGroupName(formProps.value.name))
                        .then((result) => {
                          if (result.success && result.response != null) {
                            setNameIsValidFromResponse(result.response);
                          }
                        })
                        .finally(() => setCheckingName(false));
                    }
                  }}
                  customErrors={
                    !checkingName && !isValidName && !!fields.name
                      ? ["Duplicate group name, please choose another"]
                      : errors.name
                  }
                />
                {!siteId && (
                  <Form.TypeAhead
                    label="Site"
                    field="siteId"
                    fluid
                    required
                    lookup={sitesLookup}
                    placeholder="Search for site"
                    requiredError="Site is required"
                  />
                )}
                <Form.RadioGroup
                  label="Permission"
                  field="permission"
                  options={permissionOptions}
                  inline
                  required
                  requiredError="Permission is required"
                />
              </React.Fragment>
            )}
          </Form>
        </Modal>
      )}
    />
  );
};

export default AddGroup;
